import React, { useEffect, useState } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { Col, Row, Statistic, Typography, Select, Card, Table, } from 'antd';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useMount } from 'react-use';
import { convertTimeFactor } from '../../../utils/functions';
import { timezoneAtom, refreshUserAnalyticsAtom, loadingUserAnalyticsAtom } from '../../../../atoms/Atoms';
import api from '../../../../api/api';

function Orders() {
  const [loading, setLoading] = useRecoilState(loadingUserAnalyticsAtom);
  const timezone = useRecoilValue(timezoneAtom);
  const [data, setData] = useState(null);
  const [timeFactor, setTimeFactor] = useState(0);
  const [top, setTop] = useState(1);
  const { Title } = Typography;
  const { t } = useTranslation();
  const days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15,
    16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31
  ];
  const weeks = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15,
    16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
    32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
    48, 49, 50, 51, 52
  ];
  const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const { Option, OptGroup } = Select;
  const [usersData, setUsersData] = useState(null);
  const [refresh, setRefresh] = useRecoilState(refreshUserAnalyticsAtom);

  function mapData(users) {
    const mapped = _.map(users, (p, index) => ({
      key: index,
      count: p.count,
      startDate: moment(`${p.startDate}`)
        .tz(timezone)
        .format('MMMM Do YYYY'),
      endDate: moment(`${p.endDate}`)
        .tz(timezone)
        .format('MMMM Do YYYY'),
    }));

    return mapped;
  }

  function getData() {
    setLoading(true);
    api
      .get(`analytics/orders/${timeFactor}/${top}`)
      .then((response) => {
        setLoading(false);
        setData(response.data.data);
        const map = mapData(response.data.data.ordersCreated);
        setUsersData(map);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }
  useMount(() => {
    getData();
  });

  useEffect(() => {
    getData();
  }, [timeFactor, top, refresh]);

  return (
    <div className="p-4 border bg-gray-100 rounded-lg mb-4">
      <Row align="middle" gutter={[12, 12]} justify="space-between">
        <Col span={10}>
          <Typography.Title level={5}>{t('order_analytics')}</Typography.Title>
          <Typography.Text type="secondary">
            {t('analytics_orders_description')}
          </Typography.Text>
        </Col>
        <Col span={6} gutter={2}>
          <div className="flex flex-row">
            {' '}
            <div className="mr-10">
              <Statistic title="Timespan" value={`${top} ${t(convertTimeFactor(timeFactor))}(s)`} />
            </div>
          </div>
        </Col>
        <Col span={4}>
          <div>
            <Select
              listHeight={500}
              style={{ width: 150 }}
              onChange={(value) => setTimeFactor(value)}
              defaultValue={0}
            >
              <Option disabled>{t('timeFactor_selector_description')}</Option>
              <Option value={0}>{t('days')}</Option>
              <Option value={1}>{t('weeks')}</Option>
              <Option value={2}>{t('months')}</Option>
              <Option value={3} hidden>{t('years')}</Option>
            </Select>
          </div>
        </Col>
        <Col span={4}>
          {timeFactor === 0 ?
            <div>
              <Select
                listHeight={500}
                style={{ width: 150 }}
                onChange={(value) => setTop(value)}
                defaultValue={top}
              >
                <OptGroup className="text-xs flex items-center">
                  {_.map(days, (num) => (
                    <Option
                      key={num}
                      value={num}
                      className="text-xs flex items-center"
                    >
                      {num}
                    </Option>
                  ))}
                </OptGroup>
              </Select>
            </div>
            : null}
          {timeFactor === 1 ?
            <div>
              <Select
                listHeight={500}
                style={{ width: 150 }}
                onChange={(value) => setTop(value)}
                defaultValue={top}
              >
                <OptGroup className="text-xs flex items-center">
                  {_.map(weeks, (num) => (
                    <Option
                      key={num}
                      value={num}
                      className="text-xs flex items-center"
                    >
                      {num}
                    </Option>
                  ))}
                </OptGroup>
              </Select>
            </div>
            : null}
          {timeFactor === 2 ?
            <div>
              <Select
                listHeight={500}
                style={{ width: 150 }}
                onChange={(value) => setTop(value)}
                defaultValue={top}
              >
                <OptGroup className="text-xs flex items-center">
                  {_.map(months, (num) => (
                    <Option
                      key={num}
                      value={num}
                      className="text-xs flex items-center"
                    >
                      {num}
                    </Option>
                  ))}
                </OptGroup>
              </Select>
            </div>
            : null}
        </Col>
        <Col>
          {' '}
        </Col>
      </Row>
      <br />
      <br />
      <div style={{ align: 'center' }}>
        <Row>
          <Col>
            <Card title="Total Orders" style={{ margin: 10 }}>
              {data && (
                <>
                  <Title level={4} align="center">
                    {data.totalOrders}
                  </Title>
                  <Title level={5} align="center">
                    {t('orders')}
                  </Title>
                </>
              )}
            </Card>
          </Col>
          <Col>
            <Card title="Total Pickups" style={{ margin: 10 }}>
              {data && (
                <>
                  <Title level={4} align="center">
                    {data.totalPickups}
                  </Title>
                  <Title level={5} align="center">
                    {t('pickup_orders')}
                  </Title>
                </>
              )}
            </Card>
          </Col>
          <Col>
            <Card title="Total Deliveries" style={{ margin: 10 }}>
              {data && (
                <>
                  <Title level={4} align="center">
                    {data.totalDeliveries}
                  </Title>
                  <Title level={5} align="center">
                    {t('delivery_orders')}
                  </Title>
                </>
              )}
            </Card>
          </Col>
        </Row>
      </div>
      <br />
      <br />
      <Table
        size="small"
        loading={loading}
        bordered
        pagination={false}
        columns={[
          {
            title: t('start_date'),
            dataIndex: 'startDate',
            key: 'startDate',
            align: 'left',
            className: 'text-xs',
            render: (text) => <span>{text}</span>,
          },
          {
            title: t('end_date'),
            dataIndex: 'endDate',
            key: 'endDate',
            align: 'left',
            className: 'text-xs',
            render: (text) => <span>{text}</span>,
          },
          {
            title: t('count'),
            dataIndex: 'count',
            key: 'count',
            align: 'left',
            className: 'text-xs',
            render: (text) => <span>{text}</span>,
          },
        ]}
        dataSource={usersData}
      />
    </div>
  );
}

export default Orders;
